import axios from 'axios'
import qs from 'qs'
// import { Loading } from 'element-ui'
import {BASE_URL} from './config'
import router from '../router'
import store from '../store' //store
import notify from "../components/notification/notify"

// 创建 axios 实例
let http = axios.create({
  // headers: {'Content-Type': 'application/json'},
  baseURL: BASE_URL,
  // timeout: 10000
})

// let loading
// let loadingCount = 0 // loading
let requestUrls = [] // 正在请求中的接口

// 请求开始处理函数
const _startOfRequest = (url) => {
  requestUrls = requestUrls.concat(url)
}

// 请求结束处理函数
const _endOfRequest = (url) => {
  if (!url) {
    requestUrls = []
    return
  }
  
  requestUrls = requestUrls.filter(v => v !== url)
}

// 是否token续期请求中
let isExpireing = false, refreshTimer = null
const refreshAuth = () => {
  // 防止请求并发情况下多次请求
  clearTimeout(refreshTimer)
  refreshTimer = setTimeout(() => {
    const refreshToken = localStorage.getItem('refreshToken')
    const vi = localStorage.getItem('vi') || '{}'
    
    let _param = JSON.parse(vi)
    _param.refresh_token = refreshToken
    _param.grant_type = 'refresh_token'
    
    let formData = new FormData();
    Object.keys(_param).forEach((v) => {
      // console.info(v);
      formData.append(v, _param[v]);
    });
    
    isExpireing = true
    http.post('/oauth/token', formData, {
      headers: {
        post: {'Content-Type': 'multipart/form-data'}
      }
    })
      .then(data => {
        console.log(data,61)
        localStorage.setItem('Authorization', 'bearer ' + data.access_token)
        localStorage.setItem('refreshToken', data.refresh_token);
        isExpireing = false
      })
      .catch(err => {
        console.error(err)
        isExpireing = false
      })
  }, 3000);
}


// 设置 delete、post、put 默认 Content-Type
http.defaults.headers.post['Content-Type'] = 'application/json'
http.defaults.headers.put['Content-Type'] = 'application/json'
// 添加请求拦截器
http.interceptors.request.use(config => {
  const Authorization = localStorage.getItem('Authorization')
  const eid = localStorage.getItem('eid')
  // console.info(eid, 42)
  const url = `${config.method}_${config.url}`
  
  if (requestUrls.includes(url)) {
    throw new Error('repeat url')
  }
  
  if (config.headers.belong == "home") {
    config.baseURL = process.env.VUE_APP_URL_USER;
    delete config.headers.belong
  } else if (config.headers.belong == "hr") {
    config.baseURL = process.env.VUE_APP_URL_HR;
    delete config.headers.belong
  } else if (config.headers.belong == "schedule") {
    config.baseURL = process.env.VUE_APP_URL_Schedule;
    // delete config.headers.belong
  } else if (config.headers.belong == "bulletin") {
    config.baseURL = process.env.VUE_APP_URL_Bulletin;
  }
  
  _startOfRequest(url)
  
  if (Authorization) {
    config.headers['Authorization'] = Authorization
  }
  if (eid) {
    config.headers['eid'] = eid
  }
  // config.headers['Authorization'] = 'bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJkZXB0TmFtZSI6IuaKgOacr-eglOWPkeS4reW_gyIsImF1ZCI6WyJhZG1pbiIsImNsaWVudCJdLCJ1c2VyX25hbWUiOiIxMzcyOTU2NTg3NiIsInNjb3BlIjpbImFsbCJdLCJuaWNrbmFtZSI6IumZiOeBv-ixqiIsImV4cCI6MTY0NTA4ODIzNywidXNlcklkIjoiZjM3MTcyNzM2ZWJlNGYzNWE0ZDk3Yjk3ZTUyMzcwN2YiLCJqdGkiOiIzYzc4MGI4Zi1jODZlLTQzMzItYjk0ZS1hMDkxNDg2Yzg1NGMiLCJjbGllbnRfaWQiOiJhZG1pbiIsInVzZXJuYW1lIjoiMTM3Mjk1NjU4NzYiLCJkdXR5TmFtZSI6IuWJjeerr-W8gOWPkeW3peeoi-W4iCJ9.V1lWlHiUzC0tZhWzJB8sqHcBgFGInlzQ1g5_yCnMCqVnqSLpRUb53MRWGOuYgQtjj3yl9T4_E2moQnhj6avLmc4vKvoQd820jMrRp3rbxv6_aoaAcLIS9UKxyw0PYcP4lTTwzZc-Y5wZ4pJIdpWe1WHcwns9ZQh6quA2QdE6tvZsmtSrg0S5Wgmakvor76Cc7ofklhVx1K-NPO1ncle4JKBJ4arMrmNgMxjgSRnVkA6rfOXuV0arvdTzg4Phu_z4gw_NyL_2wktiTY3vY9PU1o_0CN6S8gBEkO9LKo0V6r5nd9Hnv1koTVfaQZ4aG_7V9G77J70xMAjP3i0u5OwjQg'
  if (config.headers.noAuth) {
    delete config.headers['Authorization']
    delete config.headers.noAuth;
  }
  
  if (config.method === 'post' || config.method === 'put') {
    // post、put 提交时，将对象转换为string, 为处理Java后台解析问题
    if (config.headers.post['Content-Type'] == "application/x-www-form-urlencoded") {
      let data = config.data;
      config.data = qs.stringify(data);//对参数进行序列化
    } else if (config.headers.post['Content-Type'] == "application/json") {
      config.data = JSON.stringify(config.data)
    }
  } else if (config.method === 'get') {
    // 给GET 请求后追加时间戳， 解决IE GET 请求缓存问题
    config.params = Object.assign({}, config.params, {
      '_': Date.now()
    })
  } else if (config.method === 'delete') {
    config.data = JSON.stringify(config.params)
  }
  // 请求发送前进行处理
  
  return config
}, error => {
  // 请求错误处理
  notify({
    content: "请求失败",
    type: 'warning'
  })
  
  return Promise.reject(error)
})

// 添加响应拦截器
//之前用状态码用的数字类型，现版本改为字符串类型，因为状态码可能带有字符标识
http.interceptors.response.use(response => {
  _endOfRequest(`${response.config.method}_${response.config.url}`)
  console.log(response,148)
  let {data, headers} = response
  
  if (data.code === 200) {
    
    // console.log(isExpireing,151)
    // console.log(headers.isexpire,152)
    // console.log(headers.isexpire == 1 && !isExpireing,153)
    // console.log(headers,154)
    console.log(headers.isexpire,154)
    if (headers.isexpire == 1 && !isExpireing) {
      // 续签token
      console.log("续签token",160)
      refreshAuth()
    }
    return data.data
  } else if( data.code == 424022 ){   //外网登录后扫码验证
    return data
  }else {
    if (![424021, 424009, 300601, 300602, 300603, 300604, 300605, 400501, 400502].includes(data.code)) {
      notify({
        content: data.msg,
        type: 'warning'
      })
    }
    
    
    if (data.code === 424009) {
      if (window.location.href.indexOf('/login') < 0) {
        router.push('/login')
        store.commit('SETMSGDIALOG', null)
        localStorage.clear()
      }
    } else if ([424020, 424021, 300401, 300402, 300404].includes(data.code)) { // 424020 选择要管理的组织重新登录
      if (window.location.href.indexOf('/login') != -1) {
        notify({
          content: data.msg || '请求失败',
          type: 'warning'
        })
      } else {
        router.push('/login')
        store.commit('SETMSGDIALOG', null)
        localStorage.clear()
      }
    }
    
    return Promise.reject(data)
  }
}, error => {
  const {response: {data}} = error;
  
  if ([424021, 424009, 424010].includes(data.code)) {
    localStorage.clear()
    window.location.href = '/login'
    store.commit('SETMSGDIALOG', null)
  }
  
  if (error.message === 'repeat url') {
    console.warn('重复请求')
    
    return
  }
  
  _endOfRequest()
  
  try {
    let belong = error.response.config.headers.belong;
    if (belong == "schedule") {
      if (data.status !== 503) {
        notify({
          content: "请求失败",
          type: 'warning'
        })
      }
    } else {
      notify({
        content: "请求失败",
        type: 'warning'
      })
    }
  } catch (e) {
    notify({
      content: "请求失败",
      type: 'warning'
    })
  }
  
  return Promise.reject(error)
})

/**
 * 创建统一封装过的 axios 实例
 * @return {AxiosInstance}
 */
export default function () {
  return http
}
